import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import type { IdeaDetailResponse } from '@shared/types';
import { PageContainer, PageHeader } from '../../app/AppShell';
import { Card, CardBody } from '../../components/Card';
import { toast } from '../../components/Toast';
import { api, errorMessage } from '../../lib/api';
import { useSettingsStore } from '../admin/settingsStore';
import { IdeaForm, type IdeaFormValue } from './components/IdeaForm';

/** 新建创意。草稿与提交走同一个接口，只有校验强度不同。 */
export function IdeaNewPage() {
  const navigate = useNavigate();
  const settings = useSettingsStore((state) => state.settings);
  const loadSettings = useSettingsStore((state) => state.load);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    void loadSettings();
  }, [loadSettings]);

  const submit = async (value: IdeaFormValue, status: 'draft' | 'submitted') => {
    setSubmitting(true);
    try {
      const created = await api.post<IdeaDetailResponse>('/api/ideas', { ...value, status });
      toast.ok(status === 'draft' ? '草稿已保存' : '创意已提交');
      navigate(`/ideas/${created.id}`, { replace: true });
    } catch (error) {
      toast.critical('提交失败', errorMessage(error));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <PageContainer className="max-w-4xl">
      <PageHeader title="提出创意" description="写得越具体，AI 的研判就越有依据。提交后全员可见，并可以发起研判。" />
      <Card>
        <CardBody>
          <IdeaForm tagOptions={settings.tags} submitting={submitting} onSubmit={(value, status) => void submit(value, status)} />
        </CardBody>
      </Card>
    </PageContainer>
  );
}
